/**
 * Default providers and models for the chat model selector.
 * Shape: { provider, label, models: [{ value, label }] }
 */
export const DEFAULT_CHAT_PROVIDERS = [
  {
    provider: 'openai',
    label: 'Open AI',
    models: [
      { label: 'GPT 5.2', value: 'gpt-5.2' },
      { label: 'GPT 5.2 Pro', value: 'gpt-5.2-pro' },
    ],
  },
  {
    provider: 'anthropic',
    label: 'Anthropic',
    models: [
      { label: 'Claude Sonnet 5', value: 'claude-sonnet-5' }, 
      { label: 'Claude Sonnet 4.6', value: 'claude-sonnet-4-6' }],
  },
];
